import { Box, SvgIcon, SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
// import { ReactComponent as LogoIcon } from 'assets/icons/logo.svg';
import React from 'react';

type Props = {
  htmlColor?: string;
  sx?: SxProps<Theme>;
  onClick?: () => void;
};

export function PngCompanyLogo({ sx, onClick, htmlColor = 'white' }: Props) {
  return (
    <Box
      component="img"
      src="/icons/logo.png"
      sx={{
        width: 'auto',
        height: 'auto',
        ...sx,
      }}
      onClick={onClick}
    />
  );
}
